module.exports = __webpack_public_path__ + "img/payment-method.2ba422c7.svg";